import React, { Component } from 'react';
import './PrivacyPolicy.css';

export default function PrivacyPolicy(){
    return(
        <main className='PrivacyPolicy'>
            <h1>Privacy Policy</h1>
        </main>
    )
}